import * as React from 'react';
import moment from 'moment'

//MUI
import TextField from '@mui/material/TextField';
import Skeleton from '@mui/material/Skeleton';
import Button from '@mui/material/Button';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Box, Stack } from '@mui/material';
import API_CONSTANTS from '../resources/constants/api.json';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';


//Custom
import {downloadFile, isJsonString} from '../resources/utils/commonFunctions.js';

export default function Comments({lease_id, run_date, user_info, isPaneOpen, updateComments}) {
    const useEffect = React.useEffect;
    const useState = React.useState
    const [comments, setComments] = useState([])
    const [loading, setLoading] = useState(true)
    const [textVal, setTextVal] = useState()

    const requestPDF = async (fileName) => {
        const response = await fetch(`${API_CONSTANTS.API_ROUTE}/getPDF?fileName=${fileName}`);
        const data = await response.json();
        downloadFile(data.file, fileName, 'application/pdf');
    }

    const loadComments = async () => {
        const response = await fetch(`${API_CONSTANTS.API_ROUTE}/loadComments?lease_id=${lease_id}`);
        const data = await response.json();
        setLoading(false);
        if (data.length === 0) {
            setComments([{_id:0, email:"", comment_text: "No comments found"}]);
        } else {
            setComments(data.sort((a, b) => new Date(b.create_dttm) - new Date(a.create_dttm)));
        }
    }

    useEffect(()=>{
       loadComments()
    },[lease_id])

    const addComment = (lease_id, comment) => {
        fetch(`${API_CONSTANTS.API_ROUTE}/addComment?user_id=${user_info._id}&run_date=${run_date}&comment_text=${comment}&lease_id=${lease_id}`, {
            method: 'POST'
        }).then(async (res) => {
            if (res.status === 200) {
                const response = await fetch(`${API_CONSTANTS.API_ROUTE}/loadComments?lease_id=${lease_id}&run_date=${run_date}`);
                const latestComments = await response.json();
                updateComments(lease_id, latestComments);
                setComments(latestComments.sort((a, b) => 
                    new Date(b.create_dttm) - new Date(a.create_dttm)
                ));
                setTextVal("");
            }    
        });
    };

    const columns = [
        { 
            field: 'email', 
            headerName: 'User', 
            flex: 1,

        },
        { 
            field: 'comment_text', 
            headerName: 'Comment', 
            flex: 2,
            renderCell: (props) => {
                if (props.row.userId === -1 && isJsonString(props.row.comment_text)){
                    let parsedElement = JSON.parse(props.row.comment_text);
                    //make this better
                    if (parsedElement.type === "Button" && parsedElement.displayText === "Get Notice"){
                        return (
                            <Button onClick={()=>{requestPDF(parsedElement.funcArgs.fileName)}}>
                                {parsedElement.displayText}
                            </Button>    
                        )
                    }
                }
                else{
                    return (
                        props.comment_text
                    )
                }
            }
        }, 
        { 
            field: 'create_dttm', 
            headerName: 'Date', 
            type: 'date',
            flex: 1,

            valueGetter: (params) => {
                if(!params) return null;
                try {
                    return moment.utc(params).local().toDate();
                } catch (error) {
                    console.error('Error parsing date:', error);
                    return "N/A";
            }
            },
            valueFormatter : (params) => {
                if (!params) return "";
                return moment(params).format('MM/DD/YYYY hh:mm A');
            }
        }
    ];

    return (
        <Box width={"99%"} alignContent={"center"} alignItems={"center"}  >
            {
                loading ?
                    <div><Skeleton /><Skeleton /><Skeleton /><Skeleton /></div>: 
                    
            
            <DataGrid
                rows={comments}
                columns={columns}
                getRowId={(row) => row._id}
                loading={loading}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                       
                    }
                }}
              
                initialState={{
                    pagination: {
                        paginationModel: { pageSize: isPaneOpen ? 10 : 4 },
                    },
                    density: 'compact'
                }}
                rowHeight={45}
                
                sx={{
                    '& .MuiDataGrid-columnHeader': {
                        minHeight: '30px !important',
                        maxHeight: '30px !important',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        minHeight: '30px !important',
                        maxHeight: '30px !important',
                    },
                    '& .MuiDataGrid-footerContainer': {
                        minHeight: '22px !important',
                        maxHeight: '24px !important',
                    }
                }}
            />
            }
            <Stack direction={"row"} width="100%" justifyItems={"end"}>
                <TextField
                    fullWidth
                    id="standard-textarea"
                    label="Add Comment"
                    placeholder="Comment"
                    multiline
                    variant="standard"
                    onChange={(event)=>{setTextVal(event.target.value)}}
                    value={textVal}
                    />
                <Button 
                    disabled = {!textVal || textVal.trim() === "" } 
                    onClick={()=>{addComment(lease_id, textVal)}}>
                        <AddCircleIcon fontSize="large"/>
                </Button>
            </Stack>
        </Box>
    )
}